import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../helpers/Translator';
import { axiosPath } from '../../../../routing/helpers/router';
import useIsMounted from '../../hooks/useIsMounted';
import { AppMultiSelect, AppRemixIcon } from '@/layout/AppComponents';

export default function SelectPlantGroups(props) {
  const {
    onHandleChange,
    reset,
    error,
    type = 'all',
    title = <Translator file="user" name="module.plantGroups" />,
    elements = [],
    className = 'mb-2',
    allowSelectAll = true,
  } = props;
  const isMounted = useIsMounted();
  const [selectedValue, setSelectedValue] = useState([]);
  const [plantGroups, setPlantGroups] = useState([]);

  // > LOAD PLANT GROUPS //
  const loadPlantGroups = useCallback(async () => {
    try {
      const response = await axios.post(
        axiosPath('api_r_user_global_getPlantGroups'),
        { type, elements },
      );
      return response.data;
    } catch (err) {}
  }, []);

  useEffect(() => {
    loadPlantGroups().then((r) => {
      if (isMounted.current) {
        setPlantGroups(r);
      }
    });
  }, []);
  // < LOAD PLANT GROUPS //

  const onChange = (options) => {
    setSelectedValue(options);
    onHandleChange(options);
  };

  return (
    <AppMultiSelect
      options={plantGroups}
      onChange={(opt) => onChange(opt)}
      value={selectedValue}
      title={title}
      placeholder={ReactDOMServer.renderToString(
        <Translator file="user" name="select.one.or.multiple.plant.groups" />,
      )}
      icon={<AppRemixIcon icon="home" />}
      isClearable
      allowSelectAll={allowSelectAll}
      isLoading={!plantGroups}
      error={error}
      hasSearchBox
      hasSelectOptions
    />
  );
}
